// Centralized asset URLs — swap here to update site-wide.
// All assets are served from Emergent's asset CDN.

export const ASSETS = {
  portrait:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/euvph9ss_Professional%20Headshot.jpg",
  speaking:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/i7b7lo37_Speaking%20at%20Conference.jpg",
  running:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/zzaiy34q_Running%20Image.jpg",
  onsite:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/dayddu3v_Onsite%20Image.jpg",
  golfing:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/xpbr593i_Golfing%20Image.jpg",
  clientVisit:
    "https://customer-assets.emergentagent.com/job_vincent-performance-1/artifacts/gk8n4mwx_Client%20Visit.jpg",
};
